import { Component } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';
import { VariablesProvider } from "../../providers/variables/variables";
import { FuncionesProvider } from "../../providers/funciones/funciones";

type Msg = { role: 'user' | 'assistant'; text: string };

@IonicPage()
@Component({
  selector: 'page-ai-agent',
  templateUrl: 'ai-agent.html',
})
export class AiAgentPage {

  periodo: 'hoy' | 'semana' | 'mes' | 'custom' = 'mes';
  from: string; // ISO string
  to: string;   // ISO string

  input: string = '';
  mensajes: Msg[] = [
    { role: 'assistant', text: 'Hola 👋 Pídeme informes: llegadas tarde, ausencias, horas extra…' }
  ];

  rows: Array<{ nombre: string; tardanzas: number; media_min: number }> = [];

  constructor(
    public navCtrl: NavController,
    public funciones: FuncionesProvider,
    public variables: VariablesProvider,
    
    ) {


      
    }

  enviar() {
    const q = (this.input || '').trim();
    if (!q) return;

    this.mensajes.push({ role: 'user', text: q });

    // Demo (luego lo conectamos a tu API)
    this.mensajes.push({
      role: 'assistant',
      text: 'Perfecto. (De momento esto es una demo). En el siguiente paso lo conectamos con tu API.'
    });

    this.rows = [
      { nombre: 'Juan Pérez', tardanzas: 7, media_min: 9 },
      { nombre: 'María López', tardanzas: 5, media_min: 6 },
    ];

    this.input = '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/ai-agent/ai-agent.ts